import { Collection, Model } from 'modules/core/lib/mobx-rest'

interface INationality {
  label: string
  value: string
}

class Nationality extends Model<INationality> {
  static urlRoot() {
    return '/reports/reports/nationalities'
  }

  get primaryKey(): string {
    return 'id'
  }
}

class Nationalities extends Collection<Nationality> {
  get cacheKey(): string {
    return 'nationalities'
  }

  url() {
    return '/reports/reports/nationalities'
  }

  model() {
    return Nationality
  }
}

export default new Nationalities()
